import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { useQuery } from 'urql';
import { GraphqlOperations } from '../../../logic/graphql/operations';
import { Query } from '../../../logic/graphql/types/types';
import Auth from '../../../logic/redux/auth';
import { Paths } from '../../../navigation/paths';
import ProfileCircle from './components/profile-circle';
import './profile-menu.css';
import {FormattedMessage} from "react-intl";

const subroutes = [
  Paths.profile,
  Paths.notifications,
  Paths.personal_data,
  Paths.settings,
  Paths.login_settings,
  Paths.logout_settings,
  Paths.password_change,
];

const ProfileMenu = (): JSX.Element => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  const result = useQuery<Query>({
    query: GraphqlOperations.queries.getUserName.queryString,
  })[0];

  const { data } = result;

  const user = data?.getUser;

  const isActive = subroutes.some((r) => r === location.pathname);

  const handleItemClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
    event.stopPropagation();
    history.push(Paths.profile);
  };

  const handleLogoutClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
    event.preventDefault();
    event.stopPropagation();
    dispatch(Auth.actions.doLogout());
  };

  return (
    <div style={{ width: '100%' }}>
      <div className="profile-menuitem" onClick={handleItemClick}>
        <div className={'profile-active-sign' + (isActive ? ' active' : '')} />
        <ProfileCircle isActive={isActive} />
        <div className="profile-name-container">
          <div className="profile-name">{user && user.name}</div>
          <div className="profile-logout" onClick={handleLogoutClick}>
            <FormattedMessage id={'common.logoutButton'} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileMenu;
